import { useQuery, useSubscription } from "@apollo/react-hooks";
import { MY_TIME_GET_MESSAGES_LIST } from "my-time/graphql/queries";
import { MY_TIME_MESSAGES_SUBSCRIPTION } from "my-time/graphql/subscriptions";

export const useMyTimeMessagesList = ({ request }: { request: any }) => {
  const { data, loading, error, refetch } = useQuery(
    MY_TIME_GET_MESSAGES_LIST,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        request,
      },
    },
  );

  useSubscription(MY_TIME_MESSAGES_SUBSCRIPTION, {
    onData: () => {
      refetch();
    },
  });

  return {
    data: data?.getMyTimeMessagesList || {},
    loading: loading && !data,
    error,
  };
};

export default useMyTimeMessagesList;
